import { Button } from '@bancobarigui/barihaus';
import { Table, Space, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

import { ProtectedRouteContainer } from '@/components/ProtectedRouteContainer';
import { PageHeader } from '@/components/PageHeader';
import { ServiceCheck, FeatureAlert } from '@/shared/components';
import { useProviderCompanyList } from './useProviderCompanyList';

function ProviderCompanyListContent() {
  const {
    providers,
    loading,
    handleNew,
    handleEdit,
    handleDelete
  } = useProviderCompanyList();

  const tableColumns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: 'Nome Abreviado',
      dataIndex: 'shortName',
      key: 'shortName',
    },
    {
      title: 'CNPJ',
      dataIndex: 'cnpj',
      key: 'cnpj',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Telefone',
      key: 'phoneNumber',
      render: (_: any, record: any) => record.phones?.[0]?.phoneNumber || '-',
    },
    {
      title: 'Estado',
      dataIndex: 'state',
      key: 'state',
    },
    {
      title: 'Cidade',
      dataIndex: 'city',
      key: 'city',
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 200,
      render: (_: any, record: any) => (
        <Space size="small">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.id)}
          >
            Editar
          </Button>
          <Popconfirm
            title="Tem certeza que deseja excluir esta prestadora?"
            description="Esta ação não pode ser desfeita."
            onConfirm={() => handleDelete(record.id)}
            okText="Sim, excluir"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
            >
              Excluir
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <ProtectedRouteContainer
      pageHeader={
        <PageHeader
          title="Prestadoras"
          actions={
            <Button buttonColor="primary" onClick={handleNew}>
              Cadastrar Nova Prestadora
            </Button>
          }
        />
      }
    >
      <FeatureAlert services={['registration']} />
      <ServiceCheck services={['registration']} featureName="Prestadoras">
        <div className="flex flex-col gap-4">
          <Table
            columns={tableColumns}
            dataSource={providers}
            loading={loading}
            rowKey="id"
            pagination={{
              defaultPageSize: 10,
              showSizeChanger: true,
              showTotal: (total) => `Total de ${total} prestadoras`,
            }}
            scroll={{ x: 1200 }}
          />
        </div>
      </ServiceCheck>
    </ProtectedRouteContainer>
  );
}

export function ProviderCompanyList() {
  return <ProviderCompanyListContent />;
}
